"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessibleDatePickerButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../button");

var _icons = require("../../icons");

var _responsive = require("../../responsive");

var _screenReaderOnly = require("../../screen-reader-only");

var _utils = require("../../utils");

var _helperComponents = require("../helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AccessibleDatePickerButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var isOpen = _ref.isOpen,
      calendarButtonAltText = _ref.calendarButtonAltText,
      iconColor = _ref.iconColor,
      toggle = _ref.toggle;

  var _useBreakpoints = (0, _responsive.useBreakpoints)(),
      matches = _useBreakpoints.matches;

  var dialogueId = (0, _utils.getUniqueId)('AccessibleDatePickerButton');
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_helperComponents.DatePickerButton, {
    icon: (0, _core.jsx)(_icons.IconCalendar, {
      title: calendarButtonAltText,
      color: iconColor
    }),
    iconColor: iconColor,
    onClick: toggle,
    size: _button.ButtonSize.Small,
    variant: _button.ButtonVariant.Tertiary,
    "aria-expanded": matches.s ? undefined : isOpen,
    "aria-describedby": matches.s ? dialogueId : undefined,
    ref: ref
  }), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    id: dialogueId
  }, "has pop up dialog"));
});
exports.AccessibleDatePickerButton = AccessibleDatePickerButton;